import { Link, useParams, useNavigate } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import Preloading from '../../../components/basics/Preloading';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";

const SelectUnit = () => {
  const [gridData, setGridData] = useState([]);
  const { branchId } = useParams();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    title: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });

  const getGridData = async () => {
    const resp = await apiMethod.getUnits(filterModel.branchId, filterModel.size, filterModel.part, filterModel.title);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.title = '';
    filterModel.size = 20;
    filterModel.part = 1;
    setFilterModel({ ...filterModel })
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading />}
        {
          <>
            <div className='d-none d-lg-flex justify-content-start align-items-baseline mb-3'>
              <Link to={`/sale/${branchId}/#4`} className='link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/#4`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                منوهای فروش / بخش‌های فروش
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>منوهای فروش / بخش‌های فروش</p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row'>
                  <div className='col-12 col-md-6 col-lg-4'>
                    <label htmlFor="funit" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={filterModel.title}
                        onChange={(e) => { setFilterModel({ ...filterModel, title: e.target.value, part: 1 }) }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={() => { searchItem() }}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={() => { clearSearch() }}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='col-12 col-md-2 col-lg-4'></div>
                  <div className='col-12 col-md-4 col-lg-4'></div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                {gridData.length === 0 ? (
                  <div className='my-5'>
                    <div>
                      <span>اطلاعات مربوط به این بخش باید تکمیل شود. </span>
                      <button className='btn btn-outline-purple' onClick={() => { navigate(`/sale/:branchId/saleunits`) }}>افزودن بخش فروش</button>
                    </div>
                  </div>
                ) :
                  <>
                    <div className="row row-cols-1 row-cols-md-3 row-cols-lg-4 g-4">
                      {gridData.map((item, index) => (
                        <div className="col" key={index}>
                          <div className="card h-100">
                            <img src={methods.normalImage(item.imgSrc, 'unit')} alt={item.title} className="card-img-top p-2" style={{height:'150px'}} />
                            <div className="card-body">
                              <button
                                type="button"
                                className="btn bt-sm custome-btn btn-outline-purple w-100"
                                onClick={() => navigate(`/sale/${branchId}/${item.id}/menuCategoryManage/0`)}
                              >
                                {item.title}
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    {filterModel.parts > 1 &&
                      <nav aria-label="Page navigation example" className='mt-5'>
                        <ul className="pagination justify-content-center">
                          <li className="page-item mx-1">
                            <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                              <i className="bi bi-chevron-compact-right"></i>
                            </a>
                          </li>
                          {makePagerItems()}
                          <li className="page-item mx-1">
                            <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                              <i className="bi bi-chevron-compact-left"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    }
                  </>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };

  return (
    <>
      {renderItems()}
    </>
  );

}

export default SelectUnit;